export default {
  title: 'Tabless',
  form: {
    tabless_id: {
      label: 'ID Tabless',
      placeholder: 'Wewnętrzny ID w systemie Tabless',
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    error: 'Nie udało się zapisać zmian',
    success: 'Zmiany zostały zapisane',
  },
  connected: {
    title: 'Tabless jest połączony',
    description: 'Ta integracja jest skonfigurowana.',
  },
};
